import React from "react"
import { graphql } from "gatsby"
import Image from "gatsby-image"

import { rhythm } from "../utils/typography"
import Layout from "../components/layout"
import SEO from "../components/seo"

const Contact = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="Contact" />
      <Image
        fluid={data.mast.childImageSharp.fluid}
        alt="Me"
        style={{
          maxWidth: `100%`,
          marginBottom: rhythm(1 / 2),
          marginLeft: `auto`,
          marginRight: `auto`,
          marginTop: 0,
          maxHeight: `75vh`,
        }}
      />
    </Layout>
  )
}

export default Contact

export const pageQuery = graphql`
  query {
    mast: file(absolutePath: { regex: "/mast-contact.jpg/" }) {
      childImageSharp {
        fluid(maxWidth: 1920, quality: 100) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
  }
`
